import React from "react";
import { Camera } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/lib/motion";

export default function Gallery() {
  const { t } = useLang();
  const g = t.gallery;
  const photos = g.photos || [];

  return (
    <section id="gallery" className="py-24 md:py-32 bg-bone" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <Reveal>
            <span className="inline-block text-xs uppercase tracking-[0.22em] font-bold text-terracotta-600 mb-4">{g.overline}</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif font-light text-pine-900 text-4xl md:text-5xl leading-tight tracking-tight">{g.title}</h2>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {photos.map((p, i) => (
              <figure
                key={i}
                className="group relative overflow-hidden rounded-2xl bg-bone-100 border border-bone-200 aspect-[4/3]"
                data-testid={`gallery-photo-${i}`}
              >
                <img
                  src={p.src}
                  alt={p.caption}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-pine-900/80 via-pine-900/15 to-transparent" />
                <figcaption className="absolute bottom-0 inset-x-0 p-5">
                  <span className="flex items-start gap-2 text-bone">
                    <Camera className="w-4 h-4 text-terracotta shrink-0 mt-1" />
                    <span className="font-serif italic text-base md:text-lg leading-snug">{p.caption}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
